import React from "react";
import "../App.css";
import { Routes, Route } from "react-router-dom";

import LayoutUser from "./Users/LayoutUser";

//Componenti pagine
import HomePage from "../components/HomePage";
import PhotosPage from "../components/PhotosPage";
import BioPage from "../components/BioPage";
import ContactsPage from "../components/ContactsPage";

const MenuBar = () => {
  return (
    <>
      <Routes>
        <>
          <Route path="/" element={<LayoutUser />}>
            <Route index element={<HomePage />} />
            <Route path="home" element={<HomePage />} />

            <Route path="photos" element={<PhotosPage />} />

            <Route path="bio" element={<BioPage />} />

            <Route path="contacts" element={<ContactsPage />} />

            <Route path="*" element={<p>Not found!</p>} />
          </Route>
        </>
      </Routes>
    </>
  );
};

export default MenuBar;
